import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '', component: Layout, redirect: '/home',
    children: [
      {
        path: 'home', name: 'home',
        // component: () => import('@/views/home/index'),
        meta: {title: '首页', icon: 'home'}
      }
    ]
  }
]

export const asyncRouterMap = [

  {
    path: '/app', name: 'app', component: Layout, meta: {title: '运营数据报表', icon: 'order'}, redirect: '/app/channelManage',
    children: [
      {
        path: 'channelManage',
        name: 'channelManage',
        component: () => import('@/views/app/channelManage/index'),
        meta: {title: '渠道管理', icon: 'product-list'}
      },
      {
        path: 'riderAllManage',
        name: 'riderAllManage',
        component: () => import('@/views/app/riderAllManage/index'),
        meta: {title: '全部骑手', icon: 'product-list'}
      },
      {
        path: 'riderNewManage',
        name: 'riderNewManage',
        component: () => import('@/views/app/riderNewManage/index'),
        meta: {title: '新增骑手管理', icon: 'product-list'}
      },
      {
        path: 'riderRecallManage',
        name: 'riderRecallManage',
        component: () => import('@/views/app/riderRecallManage/index'),
        meta: {title: '召回骑手管理', icon: 'product-list'}
      },
      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/views/app/paymentRecord/index'),
        meta: {title: '收款记录', icon: 'product-list'}
      },
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/app/report/index'),
        meta: {title: '通报报表', icon: 'product-list'}
      },
      {
        path: 'settlement',
        name: 'settlement',
        component: () => import('@/views/app/settlement/index'),
        meta: {title: '结算统计', icon: 'product-list'}
      },
      {
        path: 'cabinet',
        name: 'cabinet',
        component: () => import('@/views/app/cabinet/index'),
        meta: {title: '电柜展示', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/bill', name: 'bill', component: Layout, meta: {title: '工单预警', icon: 'order'}, redirect: '/bill/billList',
    children: [
      {
        path: 'billList',
        name: 'billList',
        component: () => import('@/views/bill/billList/index'),
        meta: {title: '接单列表', icon: 'product-list'}
      },
      {
        path: 'billListOld',
        name: 'billListOld',
        component: () => import('@/views/bill/billListOld/index'),
        meta: {title: '接单列表', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/bus', name: 'bus', component: Layout, meta: {title: '活动数据报表', icon: 'order'}, redirect: '/bus/channel',
    children: [
      {
        path: 'channel',
        name: 'channel',
        component: () => import('@/views/bus/channel/index'),
        meta: {title: '渠道列表', icon: 'product-list'}
      },
      { path: 'riderNew', name: 'riderNew', component: () => import('@/views/bus/riderNew/index'), meta: {title: '新增骑手列表', icon: 'product-list'} },
      { path: 'riderRecall', name: 'riderRecall', component: () => import('@/views/bus/riderRecall/index'), meta: {title: '召回骑手列表', icon: 'product-list'} },

      {
        path: 'riderOrder',
        name: 'riderOrder',
        component: () => import('@/views/bus/riderOrder/index'),
        meta: {title: '骑手充值列表', icon: 'product-list'}
      },
      {
        path: 'riderLog',
        name: 'riderLog',
        component: () => import('@/views/bus/riderLog/index'),
        meta: {title: '扫码录入列表', icon: 'product-list'}
      },
      {
        path: 'wxUserAccount',
        name: 'wxUserAccount',
        component: () => import('@/views/bus/wxUserAccount/index'),
        meta: {title: '账户列表', icon: 'product-list'}
      },
      {
        path: 'wxUserOrder',
        name: 'wxUserOrder',
        component: () => import('@/views/bus/wxUserOrder/index'),
        meta: {title: '账户交易明细', icon: 'product-list'}
      },

      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/bus/riderNew/orderDetail'),
        meta: {title: '订单详情'},
        hidden: true
      },
      {
        path: 'deliverList',
        name: 'deliverList',
        component: () => import('@/views/bus/riderNew/deliverList'),
        meta: {title: '发货列表'},
        hidden: true
      },
      {
        path: 'invite',
        name: 'invite',
        component: () => import('@/views/bus/invite'),
        meta: {title: '推荐榜单', icon: 'product-list'}
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/bus/recharge'),
        meta: {title: '充值榜单', icon: 'product-list'}
      },
      {
        path: 'accountChange',
        name: 'accountChange',
        component: () => import('@/views/bus/wxUserAccount/accountChange'),
        meta: {title: '账户变更', icon: 'product-list'},
        hidden: true
      }
    ]
  },

  {
    path: '/battery', name: 'battery', component: Layout, meta: {title: '电池管理', icon: 'order'}, redirect: '/battery/batteryScan',
    children: [
      {
        path: 'batteryScan',
        name: 'batteryScan',
        component: () => import('@/views/battery/batteryScan/index'),
        meta: {title: '电池签收记录', icon: 'product-list'}
      },
      {
        path: 'batteryList',
        name: 'batteryList',
        component: () => import('@/views/battery/batteryList/index'),
        meta: {title: '电池列表', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/sys', name: 'sysMenu', component: Layout, meta: {title: '系统管理', icon: 'ums'}, redirect: '/sys/admin',
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/sys/admin/index'),
        meta: {title: '用户管理', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/sys/role/index'),
        meta: {title: '角色管理', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/sys/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/sys/menu/index'),
        meta: {title: '菜单管理', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/sys/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/sys/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/sys/config/index'),
        meta: {title: '系统配置', icon: 'order-setting'}
      },
      {
        path: 'addConfig',
        name: 'addConfig',
        component: () => import('@/views/sys/config/add'),
        meta: {title: '添加配置'},
        hidden: true
      },
      {
        path: 'updateConfig',
        name: 'updateConfig',
        component: () => import('@/views/sys/config/update'),
        meta: {title: '编辑配置'},
        hidden: true
      }
    ]
  },
  {
    path: '/mall', name: 'mall', component: Layout, meta: {title: '租车商城', icon: 'ums'}, redirect: '/mall/merchant',
    children: [
      {
        path: 'merchant',
        name: 'merchant',
        component: () => import('@/views/mall/merchant/merchant'),
        meta: {title: '商户管理', icon: 'ums-admin'}
      },
      {
        path: 'car',
        name: 'car',
        component: () => import('@/views/mall/car/car'),
        meta: {title: '车辆管理', icon: 'ums-admin'}
      },
      {
        path: 'carAdd',
        name: 'carAdd',
        component: () => import('@/views/mall/car/carAdd'),
        meta: {title: '车辆详情', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'merChantAdd',
        name: 'merChantAdd',
        component: () => import('@/views/mall/merChant/merChantAdd'),
        meta: {title: '商户详情', icon: 'ums-admin'},
        hidden: true
      }
    ]
  },
  {
    path: '/exchange', name: 'exchange', component: Layout, meta: {title: '兑换商城', icon: 'ums'}, redirect: '/exchange',
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/exchange/product'),
        meta: {title: '商品管理', icon: 'ums-admin'}
      },
      {
        path: 'productAdd',
        name: 'productAdd',
        component: () => import('@/views/exchange/productAdd'),
        meta: {title: '商品详情', icon: 'ums-admin'},
        hidden: true
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js